import { render, staticRenderFns } from "./AccessRegistrationHome.vue?vue&type=template&id=9e4a9b9a&scoped=true"
import script from "./AccessRegistrationHome.vue?vue&type=script&lang=js"
export * from "./AccessRegistrationHome.vue?vue&type=script&lang=js"
import style0 from "./AccessRegistrationHome.vue?vue&type=style&index=0&id=9e4a9b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4a9b9a",
  null
  
)

export default component.exports